import commonRedux from 'Core/common/redux/reducer';
// RQ-01: Import commonISRedux for shared infinite scroll state management
import commonISRedux from 'Core/common/redux/infiniteScrollSlice';
import loginRedux from 'Core/views/login/redux/reducer';
import securityRedux from 'Core/containers/Auth/redux/reducer';
import generalRedux from 'Core/containers/General/redux/reducer';
import preferencesRedux from '../../containers/Preferences/redux/reducer';
import confirmUserRedux from 'Core/views/confirmUser/redux/reducer';
import forgotPasswordRedux from 'Core/views/forgotPassword/redux/reducer';
import logoutPromptRedux from 'Core/containers/Header/.components/logoutPrompt/redux/slice';


export default {
    commonRedux,
    // RQ-01: Register commonISRedux for DataViewInfiniteScroll common Redux mode
    commonISRedux,
    loginRedux,
    securityRedux,
    generalRedux,
    confirmUserRedux,
    forgotPasswordRedux,
    preferencesRedux,
    logoutPromptRedux
};